/* Hand-written, and this is the ONE place that is legitimate.
 *
 * §20 requires Zod schemas generated from the OpenAPI spec so client and server validation cannot
 * drift — and that still holds for every resource. `/readiness` is deliberately outside it: it is an
 * operational probe, not a versioned API resource, so it has no path in `contracts/openapi/` to
 * generate from. Every future resource type MUST be generated; this file must not become the
 * precedent for hand-writing them.
 */

export type Fidelity = 'missing' | 'stub' | 'production';

export interface DegradedCapability {
  capability: string;
  fidelity: Fidelity;
  detail: string;
}

export interface PlatformReadiness {
  status: 'ready' | 'degraded';
  profile: string;
  degraded: readonly DegradedCapability[];
}

/* A narrowing guard rather than a cast. The response comes from another process, so trusting its
 * shape is the same mistake as trusting a client-supplied header — and `noUncheckedIndexedAccess`
 * would not save us from a cast that lied. */
export function isPlatformReadiness(value: unknown): value is PlatformReadiness {
  if (typeof value !== 'object' || value === null) return false;
  const candidate = value as Record<string, unknown>;
  return (
    (candidate['status'] === 'ready' || candidate['status'] === 'degraded') &&
    typeof candidate['profile'] === 'string' &&
    Array.isArray(candidate['degraded'])
  );
}
